import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '不负嘱托 奋斗有我';

const route: RouteConfig = {
  path: '/20200331FDYW',
  name: 'FDYW',
  component: () => import('./Home.vue'),
  meta: {
    title: PAGE_TITLE,
  },
};

export default route;
